import { ImportEmaMedicineContentModel } from "../../models/dataSynchronization";

export class ImportEmaMedicineModel {
  public importMedicineDataId: number;
  public medicineName: string;
  public commonINNnames: Array<string>;
  public activeSubstances: Array<string>;
  public atcCode: string;
  public authorizationHolderName: string;
  public authorizationStatusId: number;
  public emaProductNumber: string;
  public emaMedicineURL: string;
  public importEmaMedicineContents: Array<ImportEmaMedicineContentModel>
}